'use strict';

class BillingListController {
  constructor($log,
              $scope,
              $rootScope,
              $q,
              $timeout,
              $filter,
              $state,
              $stateParams,
              utils,
              config,
              VirtualPaginator,
              ToastsService) {

    // #region Define fields

    const $t = $filter('translate');
    const ALL_ORGS_LOCAL_STORAGE_KEY = 'Organizations-All';
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const SELECTED_ORGANIZATION_LOCAL_STORAGE_KEY = 'Selected-Org';

    $scope.loading = true;

    $scope.billingPage = {};
    let $billingPage = $scope.billingPage;
    $billingPage.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY); // Current org

    // Request constants
    const REQUEST_LIMIT = 100;

    $scope.selection = $state.params && $state.params.from;
    let selectedTarget = $billingPage.orgInfo;
    if ($state.params.organizationId) {
      const orgs = utils.getStorageItem(ALL_ORGS_LOCAL_STORAGE_KEY);
      selectedTarget = orgs.find(o => o.id.toString() === $state.params.organizationId.toString());
    } else {
      selectedTarget = utils.getStorageItem(SELECTED_ORGANIZATION_LOCAL_STORAGE_KEY);
    }

    // #endregion

    angular.extend($scope, {
      back: back,
    });

    init();

    function init() {
      $scope.loading = false;
    }

    function back() {
      let targetRoute = 'main.organizations.edit';
      $state.go(targetRoute, {
        tab: 'billing'
      });
    }

  }
}

export default angular
  .module('main.billingList.controller', [])
  .controller('BillingListController', BillingListController)
  .name;
